<template>
  <header class="v2 sticky">
    <div class="banner" v-if="banner">
      Powered By <img src="../assets/avris-logo-white-LR.png">
    </div>
    <div :style="{ 'margin-top': (banner ? 'var(--size-banner)' : '0px')}" style="display:flex;">
      <router-link to="/upcoming" class="logo"></router-link>
      <div class="slot">
        <slot />
      </div>
      <nav>
        <img class="wizard" src="../assets/information.svg" title="View &quot;Getting Started&quot; steps" @click="$store.commit('showGettingStarted');" />
        <div class="menu" ref="menu" @click="menuOpen = !menuOpen">
          <span class="arrow"></span>
          {{$store.getters.userFullName}} <span class="role" v-if="role">{{role}}</span>
        </div>      
        <div class="menuitems" ref="menuitems" v-if="menuOpen">          
          <a @click.stop.prevent="openSettings">Settings</a>
          <router-link to="/profile">Edit Profile</router-link>
          <!-- <router-link to="/users">Manage Users</router-link> -->
          <a @click="logout">Log Out</a>
        </div>

        <div class="settings-popup" v-if="settingsOpen" ref="settingsPopup">
          <h2>Settings
            <span v-if="loading" class="spinner" style="margin: 0; left: 80px;"></span>
          </h2>
          <div style="margin-top:8px; font-size:14px;">Email notification schedule</div>
          <div style="color:#777777; font-size:12px; margin-bottom:8px;">Select at least one</div>

          <div class="settings-checkbox">
            <label>
              <input type="checkbox" :value="1" v-model="settingsSelections" :disabled="settingsLoading || loading"> <span>Daily summary</span>
            </label>
          </div>
          <div class="settings-checkbox">
            <label>
              <input type="checkbox" :value="2" v-model="settingsSelections" :disabled="settingsLoading || loading"> <span>Weekly summary</span>
            </label>
          </div>

          <div style="clear:both; text-align: right; margin-top:12px;">
            <button class="white" @click="closeSettings" :disabled="settingsLoading">Cancel</button>
            <button :disabled="!canApply || loading || settingsLoading" @click="applySettings" style="margin-left:8px;">Apply</button>
          </div>
        </div>

      </nav>      
    </div>

    <Snackbar ref="snackbar" /> 
  </header>
</template>

<script>
import {AUTH_LOGOUT} from "../store/actions/auth";
import axios from 'axios'
import Snackbar from '@/components/Snackbar.vue'

export default {
  name: 'Header2', 
  components: {
    Snackbar
  },
  props: {
    banner: Boolean
  },
  data: function(){
    return{
      menuOpen: false,
      settingsOpen: false,
      settingsSelections: [],
      loading: false,
      settingsLoading: false,
      settingsError: undefined
    }
  },
  computed: {
    role(){
      if(this.$store.getters.isAdmin)
        return '[Admin]'
      if(this.$store.getters.isOrgAdmin)
        return '[OrgAdmin]'
      return null
    },
    canApply() {
      return this.settingsSelections && this.settingsSelections.length > 0
    }
  },
  methods: {  
    async logout(){
      await this.$store.dispatch(AUTH_LOGOUT); 
      if(this.$route.path == '/presentation')
        window.close()         
    },
    closeMenu: function(e){      
      const withinBoundaries = this.$refs.menu?.contains(e.target) || this.$refs.menuitems?.contains(e.target) || this.$refs.settingsPopup?.contains(e.target)
      if(this.menuOpen && (e.keyCode == 27 || (e.keyCode == undefined && !withinBoundaries)))
        this.menuOpen = false;
      if(this.settingsOpen && (e.keyCode == 27 || (e.keyCode == undefined && !withinBoundaries)))
        this.settingsOpen = false;
    },
    async openSettings() {
      this.menuOpen = false
      this.settingsOpen = true
      // fetch current settings when opening
      await this.loadSettings()
    },
    closeSettings() {
      this.settingsOpen = false
    },
    async applySettings() {
      if (!this.canApply) return
      try {
        this.loading = true
        this.settingsError = undefined
        await axios.post('auth/settings', { postSessionMails: this.settingsSelections })
        this.$refs.snackbar.show('Notification settings saved')
        this.settingsOpen = false
      } catch (err) {
        this.settingsError = err.response?.data?.message || 'Failed to save settings. '
        this.$refs.snackbar.show(this.settingsError + err)
      } finally {
        this.loading = false
      }
    },
    async loadSettings() {
      try {
        this.loading = true
        this.settingsError = undefined
        const resp = await axios.get('auth/settings')
        this.settingsSelections = resp.data?.postSessionMails || []
      } catch (err) {
        this.settingsError = err.response?.data?.message || 'Failed to load settings.'
        this.$refs.snackbar.show(this.settingsError + err)
      } finally {
        this.loading = false
      }
    }
  },
  mounted: function(){
    window.addEventListener("keyup", this.closeMenu, false);
    window.addEventListener("click", this.closeMenu, false);
  },
  beforeDestroy: function(){
    window.removeEventListener("keyup", this.closeMenu, false);
    window.removeEventListener("click", this.closeMenu, false);
  }
}
</script>

<style lang="scss">

header.v2{
  height: var(--size-header);
  border-bottom: $bordermixin;
  background-color: white;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);

  &.sticky{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 21;
  }

  .banner{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 21;
    height: var(--size-banner);
    background-color: #22292a;
    text-align: center;
    color: white;
    font-size: 12px;
    line-height: var(--size-banner);

    img{
      height: calc(var(--size-banner) - 2px);
      vertical-align: middle;
      margin-left: 10px;
    }
  }
  
  .logo{
    height: 32px;
    width: 92px;
    margin: 8px 24px;
    float: left;
    background-image: url("../assets/inseadxr-logo.webp");
    background-size: contain;   
    background-repeat: no-repeat;     
  }
  a.logo:hover{
    background-color: white;
    background-image: url("../assets/inseadxr-logo.webp");
    background-size: contain;  
  }

  .slot{
    flex-grow: 1;
  }

  nav{
    font-size: 15px;
    line-height: 18px;
    float: right;
    margin: 8px 24px;
    display: flex;
    align-items: center;

    .wizard{
      width:18px;
      height:18px;
      cursor: pointer;      
      margin-right: 24px;
    }

    .menu{
      padding: 7px;

      &:hover{
          background: #E9F4EA;
          border-radius: 5px;
          cursor: pointer;
      }
    }

    .role{
      font-size: 12px;
      vertical-align: bottom;
      font-weight: bold;
      padding-left: 5px;
    }

    .menuitems{
      padding: 16px;
      position: absolute;
      right: 20px;
      top: 40px;
      background: white;
      border: $bordermixin;
      box-sizing: border-box;
      box-shadow: $shadowS;
      border-radius: 5px;
      z-index: 100;

      a {
        display: block;
        text-decoration: none !important;
      }
    }

    .settings-popup{
      position: fixed;
      right: 20px;
      top: 40px;
      padding: 16px;
      background: white;
      border: $bordermixin;
      box-shadow: $shadowS;
      border-radius: 5px;
      z-index: 200;
      width: 300px;

      h2{
        margin: 0 0 8px 0;
        font-size: 16px;
        font-weight: bold;
      }

      button{
        min-width: 100px;
      }

      .settings-checkbox{
        clear: both;
        display: inline-block;
        width: 100%;

        label{
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          margin: 0;
          cursor: pointer;
        }
      }
    }

    span.arrow{
      background-image: url("../assets/arrow-icon.svg");
      background-size: contain;
      background-position: top;
      background-repeat: no-repeat;
      width: 14px;
      height: 9px;
      display: inline-block;
      margin-right: 8px;      
    }
  }

  @media (min-width: 1440px){
      .banner{
        font-size: 14px;      
      }
      .logo{    
        height: 36px;
        width: 102px;
        margin: 8px 24px;
      }
      nav{
        margin: 10px 24px;
      }
  }

  @media (min-width: 1600px){ 
      .logo{    
        height: 38px;
        width: 112px;
        margin: 8px 24px;
      }
      nav{
        margin: 13px 24px;
      }
  }

  @media (min-width: 1920px){ 
    .banner{
      font-size: 16px;      
    }
    .logo{    
      width: 164px;
      height: 58px;
      margin: 6px 24px;
    }
    nav{
      margin: 19px 24px;

      .wizard{
        width:24px;
        height:24px;
      }
    }
  }
}

</style>
